import { useCallback, useEffect, useState } from "react";

export type StepperActions = Omit<ReturnType<typeof useStepper>, "currentStep">;

export const useStepper = <T, U extends T[]>(
  steps: U,
  initialStep: T = steps[0],
) => {
  const [currentStep, setCurrentStep] = useState<T>(initialStep);

  const reset = useCallback(
    () => setCurrentStep(initialStep),
    [setCurrentStep, initialStep],
  );

  const goToNextStep = () => {
    const nextStep = steps[steps.indexOf(currentStep) + 1];

    if (nextStep) {
      setCurrentStep(nextStep);
    }
  };

  useEffect(() => reset(), [reset]);

  return {
    currentStep,
    goToNextStep,
    reset,
  };
};
